import React, { useLayoutEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getStripComponentFromStripData } from "./../../services/pursuit/stripsService";
import moment from 'moment';
import { storageService } from "../../services/storageService";
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import StripStoriesCarousel from "../../strips/flyover/stripStoriesCarousel";
import { checkShowGeoSegmentationStrips } from "../../services/geoSegmentationService";
import ContentHubPage from "./contentHubPage";
export function navigateToBookingUrlWithCurrency(url, target) {
    // using props.selectedCurrency will not work
    var selectedCurrency = storageService.get("selectedCurrency", true);
    if (!url || !selectedCurrency) {
        return false;
    }
    var normalizedUrl = (url || "").toLowerCase();
    var isBookingUrl = normalizedUrl.indexOf("bookings.") >= 0 || normalizedUrl.indexOf("viadibe") >= 0 || normalizedUrl.indexOf("ibedev") >= 0;
    if (!isBookingUrl) {
        return false;
    }
    var newUrl = updateQueryString(url, "currency", selectedCurrency);
    window.open(newUrl, target !== null && target !== void 0 ? target : "_self");
    return true;
}
;
var updateQueryString = function (url, key, value) {
    if (!url)
        url = window.location.href;
    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"), hash;
    if (re.test(url)) {
        if (typeof value !== 'undefined' && value !== null) {
            return url.replace(re, '$1' + key + "=" + value + '$2$3');
        }
        else {
            hash = url.split('#');
            url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
            if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                url += '#' + hash[1];
            }
            return url;
        }
    }
    else {
        if (typeof value !== 'undefined' && value !== null) {
            var separator = url.indexOf('?') !== -1 ? '&' : '?';
            hash = url.split('#');
            url = hash[0] + separator + key + '=' + value;
            if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                url += '#' + hash[1];
            }
            return url;
        }
        else {
            return url;
        }
    }
};
export default function Root(_a) {
    var pagesData = _a.pagesData, labels = _a.labels, rootUrl = _a.rootUrl;
    var navigate = useNavigate();
    var location = useLocation();
    var openCustomModal = function (modalID) {
        var event = new Event('openModal' + modalID);
        window.dispatchEvent(event);
    };
    var handleModalTriggerClick = function (event) {
        console.log("trigger modal: ");
        event.preventDefault();
        var link = event.target;
        var anchor = link.getAttribute('data-target');
        if (anchor && anchor[0] == "#") {
            anchor = anchor.slice(1);
        }
        anchor && openCustomModal(anchor);
    };
    var handleStripLinkClick = function (event) {
        console.log("hande nav link", event);
        var link = event.target;
        if (link.tagName !== 'A') {
            link = link.closest('a');
        }
        if (!link)
            return;
        var url = link.getAttribute('href');
        var target = link.getAttribute('target');
        if (!url || url == "#") {
            event.preventDefault();
            return;
        }
        if (url && url[0] == "#") {
            var anchor = url.slice(1);
            var anchorEl = anchor && document.getElementById(anchor);
            if (anchor && !anchorEl) {
                event.preventDefault();
                openCustomModal(anchor);
                return;
            }
        }
        if (target != '_blank' && pagesData && pagesData.siteConfig) {
            // link is to another region so we don't need to navigate with react router
            if ((pagesData.siteConfig.rootUrl || "").length > 2 && url.toLowerCase().indexOf(pagesData.siteConfig.rootUrl.toLowerCase()) < 0) {
                event.preventDefault();
                window.open(url, target !== null && target !== void 0 ? target : "_self");
                return;
            }
            var foundIndex = pagesData.siteConfig.otherRootUrls && pagesData.siteConfig.otherRootUrls.findIndex(function (otherRootUrl) {
                if (url.toLowerCase().indexOf(otherRootUrl.toLowerCase()) >= 0) {
                    return true;
                }
            });
            if (foundIndex >= 0) {
                // link is to another region so we don't need to navigate with react router
                event.preventDefault();
                window.open(url, target !== null && target !== void 0 ? target : "_self");
                return;
            }
            // foundIndex
        }
        if (target === '_blank') {
            navigateToBookingUrlWithCurrency(url, target) && event.preventDefault();
            return;
        }
        if (url[0] == '/' && url.indexOf('/getmedia') < 0) {
            event.preventDefault();
            navigate(url);
            return;
        }
        navigateToBookingUrlWithCurrency(url, target) && event.preventDefault();
    };
    useLayoutEffect(function () {
        checkShowGeoSegmentationStrips();
        var links = document.querySelectorAll('a');
        links.forEach(function (link) {
            var href = link.getAttribute('href');
            if (href && href.startsWith('#') && link.classList.contains('btn')) {
                link.classList.add('arrow-down');
            }
        });
        links.forEach(function (link) { return link.addEventListener('click', handleStripLinkClick); });
        var modalTriggers = document.querySelectorAll('[data-target="#myModal"]');
        modalTriggers.forEach(function (link) { return link.addEventListener('click', handleModalTriggerClick); });
        var tables = document.querySelectorAll("table");
        tables.forEach(function (table) {
            var _a, _b;
            if (!((_a = table.parentElement) === null || _a === void 0 ? void 0 : _a.classList.contains("table-responsive"))) {
                var wrapper = document.createElement("div");
                wrapper.classList.add("table-responsive");
                (_b = table.parentNode) === null || _b === void 0 ? void 0 : _b.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            }
            var rowgroupHeaders = table.querySelectorAll('th[scope="rowgroup"]');
            rowgroupHeaders.forEach(function (header) {
                if (!header.querySelector('span')) {
                    var content = header.textContent;
                    header.textContent = '';
                    var span = document.createElement('span');
                    span.textContent = content;
                    header.appendChild(span);
                }
            });
        });
        var checkBioAlignment = function () {
            var bioInfos = document.querySelectorAll('.bio-info');
            bioInfos.forEach(function (bioInfo) {
                var imgContainer = bioInfo.querySelector('.img-container');
                var rightSide = bioInfo.querySelector('.right-side');
                var img = imgContainer === null || imgContainer === void 0 ? void 0 : imgContainer.querySelector('img');
                if (imgContainer && rightSide && img) {
                    var checkAndSetAlignment = function () {
                        var rightSideContent = rightSide.scrollHeight;
                        var imgContent = imgContainer.scrollHeight;
                        if (rightSideContent > imgContent) {
                            requestAnimationFrame(function () {
                                bioInfo.classList.add('align-items-start');
                            });
                        }
                    };
                    if (img.complete) {
                        checkAndSetAlignment();
                    }
                    else {
                        img.onload = checkAndSetAlignment;
                    }
                }
            });
        };
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.addedNodes.length > 0) {
                    checkBioAlignment();
                }
            });
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        checkBioAlignment();
        setTimeout(checkBioAlignment, 300);
        return function () {
            links.forEach(function (link) { return link.removeEventListener('click', handleStripLinkClick); });
            modalTriggers.forEach(function (link) { return link.removeEventListener('click', handleModalTriggerClick); });
            observer.disconnect();
        };
    }, [location]);
    useLayoutEffect(function () {
        var anchor = window.location.hash.slice(1);
        if (anchor) {
            var anchorEl_1 = document.getElementById(anchor);
            if (anchorEl_1) {
                setTimeout(function () {
                    anchorEl_1.scrollIntoView();
                }, 500);
            }
            else {
                openCustomModal(anchor);
            }
        }
    }, []);
    // console.log("Root, received pages data: ", pagesData, location);
    { /*  {navigation.state === "loading" ? <div>Loading ...</div> : null}*/ }
    if (pagesData.page.pageClassName == "brewster.contentpage") {
        return React.createElement(ContentHubPage, { pagesData: pagesData, labels: labels, rootUrl: rootUrl, handleStripLinkClick: handleStripLinkClick });
    }
    else if (pagesData.page.pageClassName == "sky23.story") {
        var storyTitle = pagesData.page.fields.title ? pagesData.page.fields.title : "";
        var firstBanner = pagesData.page.strips.length > 0
            ? getStripComponentFromStripData(pagesData.page.strips.find(function (it) { return it.stripClassName == "sky23.heroimagebanner"; }), { labels: labels })
            : null;
        var formatDate = pagesData.page.fields.date ? moment(pagesData.page.fields.date).format('D MMMM YYYY') : "";
        var timeToRead = pagesData.page.fields.timeToRead ? pagesData.page.fields.timeToRead : "";
        var dateAndTimeRead = {
            date: formatDate,
            timeRead: timeToRead
        };
        var renderFirstContentStrip = false;
        var titleStrip_1 = pagesData.page.strips.find(function (x) { return (x.stripClassName == "sky23.content" && x.fields.displayTitle && x.fields.displayTitle.length > 0); });
        //.map((stripData: any, i: any) => {
        //    return getStripComponentFromStripData(stripData, { labels: labels });
        //}).filter((it: any) => !!it);
        var otherStrips = pagesData.page.strips.filter(function (it) { return (it.stripClassName != "sky23.heroimagebanner" && it.stripClassName != "sky23.herostoriescontainermanuallyselected" && it.stripClassName != "sky23.herostoriescontainer" && it != titleStrip_1); })
            .map(function (stripData, i) {
            return getStripComponentFromStripData(stripData, { labels: labels });
        }).filter(function (it) { return !!it; });
        var storiesStrip = pagesData.page.strips.filter(function (it) { return (it.stripClassName == "sky23.herostoriescontainermanuallyselected" || it.stripClassName == "sky23.herostoriescontainer"); })
            .map(function (stripData, i) {
            return getStripComponentFromStripData(stripData, { labels: labels });
        }).filter(function (it) { return !!it; });
        // not needed for now
        //let bgColor = (pagesData && pagesData.page && pagesData.page.fields && pagesData.page.fields.backgroundColor) ? pagesData.page.fields.backgroundColor : "black";
        //let textColor = (pagesData && pagesData.page && pagesData.page.fields && pagesData.page.fields.textColor) ? pagesData.page.fields.textColor : "white";
        //let fullBgColor = ' bg-' + (bgColor && bgColor != 'inherit' ? bgColor : 'black');
        //let fulltextColor = ' text-color-' + (textColor && textColor != 'inherit' ? textColor : 'white');
        //
        //let similarStories = sessionStorage.getItem('similarStories');
        //let parseSimilarStories = similarStories ? JSON.parse(similarStories) : null;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "detailed-page-content" },
                React.createElement("div", { className: "container-fluid narrow" },
                    React.createElement("div", { className: "stories-breadcrumb mt-5 container-fluid position-relative" },
                        React.createElement(Breadcrumb, null,
                            React.createElement(BreadcrumbItem, null,
                                React.createElement(Link, { to: rootUrl || "/", className: "", title: "Home" }, "Home")),
                            React.createElement(BreadcrumbItem, null,
                                React.createElement(Link, { to: (rootUrl || "") + "stories/", className: "", title: "Stories" }, "Stories")),
                            React.createElement(BreadcrumbItem, { className: "", active: true }, storyTitle))),
                    titleStrip_1 &&
                        getStripComponentFromStripData(titleStrip_1, { labels: labels }),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col" },
                            React.createElement("div", { className: "date-time-to-read px-2 mb-4 pb-2" },
                                React.createElement("span", { className: "article-date me-4" }, formatDate),
                                React.createElement("span", { className: "time-to-read" }, timeToRead)))))),
            pagesData.page.fields.featuredImage &&
                React.createElement("div", { className: "story-banner-image" },
                    React.createElement("img", { className: "img-fluid", src: pagesData.page.fields.featuredImage, alt: pagesData.page.fields.featuredImage_description ? pagesData.page.fields.featuredImage_description : "FlyOver" })),
            React.createElement("div", { className: "detailed-page-content" },
                React.createElement("div", { className: "container-fluid narrow" }, otherStrips && otherStrips.length ? (React.createElement(React.Fragment, null, otherStrips)) : (null))),
            React.createElement("div", null,
                React.createElement(StripStoriesCarousel, { storyId: pagesData.pageID, storiesListing: pagesData.page.fields.dataSourceItems }))));
    }
    else {
        var stripElements = pagesData.page.strips
            .map(function (stripData) {
            return getStripComponentFromStripData(stripData, { labels: labels, handleStripLinkClick: handleStripLinkClick, page: pagesData.page, generalSettings: pagesData.siteConfig && pagesData.siteConfig.generalSettings });
        })
            .filter(function (it) { return !!it; });
        return (React.createElement(React.Fragment, null,
            window.location.pathname.split('/').join('').toLocaleLowerCase() === "stories" &&
                React.createElement("div", { className: "stories-breadcrumb container-fluid position-relative mt-5" },
                    React.createElement(Breadcrumb, null,
                        React.createElement(BreadcrumbItem, null,
                            React.createElement(Link, { to: "/", className: "", title: "Home" }, "Home")),
                        React.createElement(BreadcrumbItem, { active: true, className: "" }, "Stories"))),
            stripElements && stripElements.length ? (React.createElement(React.Fragment, null, stripElements)) : (React.createElement("p", null))));
        /*  <Outlet />*/
    }
}
